<template>
    <Carousel class="" :perPage="perPage" :scrollPerPage="scrollPerPage" :mouse-drag="false" :autoplay="autoplay" :autoplayHoverPause="autoplayHoverPause" :loop="loop" :paginationEnabled="paginationEnabled" :autoplayTimeout="autoplayTimeout">
        <Slide class="slide" v-for="pic in pics" :key="pic.pathLong">
            <!-- <div class="image-slide" :class="{ home: homeProp ? true : false, backstyle: fill ? true : false}" :style="{ backgroundImage: `url(${pic.pathLong})`}"></div> -->
            <img class="image-slide" :src="pic.pathLong" />
        </Slide>
    </Carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'carousel',
    data () {
        return {
            perPage: 1,
            autoplay: true,
            autoplayTimeout: 0,
            autoplayHoverPause: false,
            loop: true,
            paginationEnabled: false,
            fill: false,
        }
    },
    props:['pics', 'homeProp', 'perPageCount', 'fillBool', 'fast', 'scrollPerPage'],
    components: {
      Carousel,
      Slide
    },
    methods: {
    },
    mounted: function() {
        this.fill = this.fillBool
        this.autoplayTimeout = this.fast
        this.perPage = this.perPageCount
        console.log("SCROLL", this.scrollPerPage)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.backstyle {
    max-height: 100px;
    -webkit-background-size: contain;
    -moz-background-size: contain;
    -o-background-size: contain;
    background-size: contain;
}
.image-slide {
    height: 20%;
}
.image-slide {
    /* -webkit-filter:  grayscale(100%) brightness(60%) contrast(100%); */
    height: 70px;
    width: auto;
    background-position-x: center;
    background-position-y: center;
    background-repeat: no-repeat;
    background-position: fixed;
}
</style>
